<template>

   <div class=" px-6 py-8 rounded-lg bg-blue-imbt hover:bg-blue-hov hover:text-white">
      <p class="text-blue-textm hover:text-white text-base  "><span class="font-semibold text-2xl pb-4">Wood</span></p>
      
     
     <ul class="list-disc marker:text-blue-500 text-base text-blue-textm hover:text-white text-base pl-5">
        <LI>Kitchen units</LI>
        <li>Doors </li>
        <li>Ceiling boards</li>
        
        <li>Wardrobes</li>
        <li>Repairs & Remodeling</li>
        
      
     </ul>
       </div>

</template>
<script>
 export default {
     name: 'Wood',
 }
</script>